import { render, staticRenderFns } from "./ModalListAttendanceInconsistencies.vue?vue&type=template&id=4fd28b7c"
import script from "./ModalListAttendanceInconsistencies.vue?vue&type=script&lang=js"
export * from "./ModalListAttendanceInconsistencies.vue?vue&type=script&lang=js"
import style0 from "./ModalListAttendanceInconsistencies.vue?vue&type=style&index=0&id=4fd28b7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports